import { PodcastType } from '@elsevier-health/osmosis-shared/types/podcast';
import { Box } from '@osmosis/tailwind-ui/components/Box';
import { H4 } from '@osmosis/tailwind-ui/components/Text';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { iconMap } from './icons';

type Props = {
  podcast: PodcastType;
};

/**
 * Podcast subscribe icons.
 */
const PodcastSubscribe = ({ podcast }: Props) => {
  return (
    <Box cn="flex flex-col gap-2">
      <H4>
        <FormattedMessage
          id="podcast-banner.subscribe"
          defaultMessage="Subscribe"
        />
      </H4>
      <Box cn="flex flex-wrap gap-8">
        {podcast.channels.map((channel) => {
          const icon = iconMap[channel.distribution_channel.name.toLowerCase()];

          return (
            <Box key={channel.id}>
              {icon && (
                <a href={channel.url}>
                  <Box cn="hover:scale-110 transition-all w-[30px] h-[30px] flex items-center justify-center">
                    {icon}
                  </Box>
                </a>
              )}
              {!icon && (
                <a href={channel.url}>
                  <Box>{channel.distribution_channel.name}</Box>
                </a>
              )}
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

export default PodcastSubscribe;
